/**编辑表格宽高弹框 */
<template>
  <el-popover
    placement="left"
    :hide-after="0"
    popper-class="header-popover-card"
    :visible="visible"
    :width="160"
    :topic="topic"
  >
    <template #reference>
      <slot name="content"></slot>
    </template>
    <template #default>
      <div class="popover-content">
        <div class="popover-title">{{ topic }}</div>
        <div class="popover-text">
          <div class="text-input">
            <el-input v-model="settingNumber" :placeholder="`请输入${topic}`" />
          </div>
        </div>
        <div class="popover-button">
          <el-button @click="handleClickCancel">取消</el-button>
          <el-button type="primary" @click="handleClickConfirm">确定</el-button>
        </div>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { ref, defineProps, defineEmits } from "vue";
const emits = defineEmits(["update:visible", "update"]);
const props = defineProps({
  topic: {
    type: String,
    default: "",
  },
  visible: {
    type: Boolean,
    default: false,
  },
});
const settingNumber = ref(null);

//取消设置行高
const handleClickCancel = () => {
  settingNumber.value = "";
  closePopper();
};
//确认行高
const handleClickConfirm = () => {
  if (settingNumber.value) {
    emits("update", settingNumber.value);
  } else {
    ElMessage.warning("请输入");
    return;
  }
  closePopper();
};
//关闭card
const closePopper = () => {
  emits("update:visible", false);
  settingNumber.value = "";
};
</script>

<style lang="scss" scoped>
.header-popover-card {
  .popover-content {
    padding: 10px 10px;
    .popover-title {
      font-size: 13px;
    }
    .popover-text {
      width: 100%;
      margin-top: 10px;
      .text-input {
        height: 30px;
        width: 100%;
      }
      :deep(.el-input__inner) {
        font-size: 12px;
      }
    }
    .popover-button {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .el-button {
        width: 50px;
        height: 26px;
        border-radius: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>
